var React = require('react');

function Fo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M-78 32h640v480H-78z"}))),React.createElement("g",{"fillRule":"evenodd","strokeWidth":"0","clipPath":"url(#a)","transform":"translate(78 -32)","key":1},[React.createElement("path",{"fill":"#fff","d":"M-78 32h663.9v480H-78z","key":0}),React.createElement("path",{"fill":"#003897","d":"M-76 218.7h185.9V32H216v186.7h371.8v106.6H216V512H109.9V325.3h-186V218.7z","key":1}),React.createElement("path",{"fill":"#d72828","d":"M-76 245.3h212.4V32h53.1v213.3H588v53.4H189.5V512h-53V298.7H-76v-53.4z","key":2})])]);
}

Fo.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Fo;

Fo.default = Fo;
